var React = require('react');

function SocialFacebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m15.3377462 16h-3.3377462v-4.6470909h1.7662826l.2337174-1.81085201h-2v-1.1564611c0-.52429723.1457874-.88156461.8976056-.88156461l1.1654818-.00032687v-1.61996077c-.1660538-.0219002-.9415707-.07125736-1.6038245-.07125736-1.3826918 0-2.4592629.84397472-2.4592629 2.39398562v1.33558509h-1.43384817v1.81085201h1.43384817v4.6470909h-5.33774618c-.36577593 0-.66225382-.2967967-.66225382-.6625626v-10.67487475c0-.36609283.29647789-.66256265.66225382-.66256265h10.67549238c.3657759 0 .6622538.29646982.6622538.66256265v10.67487475c0 .3657659-.2964779.6625626-.6622538.6625626z","fillRule":"evenodd"}));
}

SocialFacebook.defaultProps = {"height":"20","viewBox":"0 0 20 20","width":"20"};

module.exports = SocialFacebook;

SocialFacebook.default = SocialFacebook;
